// "Check in anyway" marker (GIS-271).
//
// The PWA and iOS check-in gate asks a member to confirm they are at the event.
// When they skip it ("Check in anyway"), the app writes two keys on the
// member's own eventUsers entry after the check-in lands:
//   checkInUnverified: true
//   checkInGatePhase:  location_off | gps_error | too_far | timeout
// firestore.rules (checkInGateMarkerOk) types both. The marker is a hint for
// the host, not proof: a member can clear it by re-saving their RSVP.

export const LOCATION_NOT_VERIFIED = "Location not verified";

const PHASE_DETAIL = {
  location_off: "Location was off on their phone.",
  gps_error: "Their phone couldn't get a GPS signal.",
  too_far: "Their phone showed them too far from the event.",
  timeout: "Their phone didn't find their location in time.",
};

export const isCheckInUnverified = (entry) => entry?.checkInUnverified === true;

/** One or two plain sentences saying why, for a tooltip or a detail line. */
export const checkInGateDetail = (entry) => {
  const detail = PHASE_DETAIL[entry?.checkInGatePhase];
  const lead = 'They checked in with "Check in anyway".';
  return detail ? `${lead} ${detail}` : lead;
};
